module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "wordbank"
    }
  }, [_vm._c('h4', [_vm._v("Select a word")]), _vm._v(" "), _vm._l((_vm.words), function(word) {
    return _vm._c('WordbankWord', {
      attrs: {
        "word": word
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46797a08!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/Wordbank.vue
// module id = 653
// module chunks = 1